<template>
    <v-layout row class="sort-selector">
        <v-flex class="flex-grow-overwrite">{{communityDirectoryPageConstant.label.SORT_BY}}</v-flex>
        <v-flex class="sort-selection">
            {{currentSort.label}}
        </v-flex>
    </v-layout>
</template>
<script>
    import { mapActions, mapGetters, mapMutations } from 'vuex';
    import { storeGetters } from "../../store/storeGetters.constant";
    import { storeAction } from "../../store/storeActions.constant";
    import { sortOptions, communityDirectoryPageConstant } from './communityDirectoryPage.constants';
    import { storeMutation } from "../../store/storeMutations.constant";
    import { appConstant } from "../../app.constant";
    import { removeLetterFilterForRolodex } from "../EventDirectoryPage/eventDirectoryPage.constants";

    export default {
        name: 'SortCommunitiesByOptions',
        data() {
            return {
                communityDirectoryPageConstant,
                sortOptions,
            };
        },
        watch: {
            currentSort() {
                if (this.communityDirectorySelectedLetterFilter) {
                    this.removeCommunityPillFromState(this.communityDirectorySelectedLetterFilter);
                    this.setCommunitySelectedLetterFilter();
                }

                removeLetterFilterForRolodex(
                    this.$route.query,
                    this.$router,
                    appConstant.storageKeys.communityDirectoryStoredFilters,
                );
                this.getCommunityDirectoryResults();
            },
        },
        methods: {
            ...mapActions({
                getCommunityDirectoryResults: `communityDirectory/${storeAction.getInitialCommunityDirectorySearchResults}`,
            }),
            ...mapMutations({
                setCommunityDirectorySort: `communityDirectory/${storeMutation.setCommunityDirectorySort}`,
                setCommunitySelectedLetterFilter: `communityDirectory/${storeMutation.setCommunitySelectedLetterFilter}`,
                removeCommunityPillFromState: `communityDirectory/${storeMutation.removeCommunityPillFromState}`,
            }),
            close() {
                this.handleClose(this.pillItem);
            },
        },
        computed: {
            ...mapGetters({
                communityDirectorySort: `communityDirectory/${storeGetters.communityDirectorySort}`,
                communityDirectorySelectedLetterFilter: `communityDirectory/${storeGetters.communityDirectorySelectedLetterFilter}`,
            }),
            currentSort: {
                get() {
                    return this.communityDirectorySort;
                },
                set(value) {
                    this.setCommunityDirectorySort(value);
                },
            },
        },
    };
</script>

<style lang="scss" scoped>
    @import '../../common/styles/_colors.scss';
    @import '../../common/styles/_responsive.scss';

    .sort-selector {
        background-color: $ypo-tile-bgcolor;
        line-height: 24px;
        width: 195px;
        padding: 10px;

        @include breakpoint(xs) {
            padding: 10px 5px;
            width: 185px;
        }

        & > * {
            vertical-align: middle;
        }

    }

    .sort-selection {
        padding-left: 5px;
        position: relative;
    }
</style>
